<div class="related-item-container" (click)="clickedItem(upc)"
     [ngClass]="[selectedFrameUpc == upc ? 'active' : '']">
  <div class="related-item__image">
      <img [src]="image" [alt]="name" onError="this.src='/assets/images/frame-default-lg.png'">
  </div>
  <div class="related-item__desc1">{{ desc1 }}</div>
</div>
